export class TempFormData {
  questionData: QuestionData[];

  constructor($questionData: QuestionData[]) {
    this.questionData = $questionData;
  }
}

export class QuestionData {
  order: number;
  questionTitle: string;
  responses: ResponseData[];

  constructor(
    $order: number,
    $questionTitle: string,
    $responses: ResponseData[]
  ) {
    this.order = $order;
    this.questionTitle = $questionTitle;
    this.responses = $responses;
  }
}

export class ResponseData {
  responseIdentificator: number;
  responseTitle: string;

  constructor($responseIdentificator: number, $responseTitle: string) {
    this.responseIdentificator = $responseIdentificator;
    this.responseTitle = $responseTitle;
  }
}
